export default __webpack_public_path__ + "static/media/empService.ef371dfd.svg";